<template>
  <v-content>
    <div id="core-view">
      <!-- <v-fade-transition mode="out-in"> -->
      <!-- determine what layout to use here using directive -->
      <layout-main>
        <router-view />
      </layout-main>
      <!-- </v-fade-transition> -->
    </div>
    <core-footer v-if="$route.name !== 'Maps'" />
  </v-content>
</template>

<script>

import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  metaInfo () {
    return {
      title: 'AWS Galaxy - Account Inventory'
    }
  },
  computed: {
    ...mapState('app', ['networkError'])
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
  height:98%;
}
#core-view .container {
  padding-top: 0;
}
</style>
